import RevisionNoteCard from './RevisionNoteCard';

function RevisionNotesList({ data = [], handleDelete }) {
  return (
    <div className="row revisionListContainer">
      {!data.length ? (
        <div className="empty-section">No revision notes available</div>
      ) : (
        <>
          <div className="col-12">
            <span className=" col-12 mt-5 mb-5 conaddtitle boldtitle">Added Revision Note</span>
          </div>

          <div className="slider">
            <div className="sliderSec">
              {data.map((note) => (
                <RevisionNoteCard key={note._id} note={note} handleDelete={handleDelete} />
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default RevisionNotesList;
